import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=71f2ac9a&scoped=true"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js"
import style0 from "./InstitutionDetails.vue?vue&type=style&index=0&id=71f2ac9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2ac9a",
  null
  
)

export default component.exports